<template>
  <b-modal
    id="edit-agent-subscription-modal"
    centered
    hide-footer
    title="Edit Agent Subscription"
  >

    <b-form-group label="Agent">
      <b-form-select v-model="agent" :options="agentOptions" disabled/>
    </b-form-group>

    <b-form-group label="Subscription Plan">
      <b-form-select v-model="plan" :options="planOptions"/>
    </b-form-group>

    <b-form-group label="Start Date">
      <b-form-input type="date" v-model="start_date"/>
    </b-form-group>

    <b-form-group label="End Date">
      <b-form-input type="date" v-model="end_date"/>
    </b-form-group>

    <b-form-checkbox v-model="is_active">
      Active Subscription
    </b-form-checkbox>

    <div class="text-right mt-3">
      <b-button variant="primary" @click="submit">
        Edit
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: { subscription: Object },

  data() {
    return {
      agent: null,
      plan: null,
      start_date: "",
      end_date: "",
      is_active: true,
      agentOptions: [],
      planOptions: []
    };
  },

  watch: {
    subscription: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.agent = newVal.agent;
          this.plan = newVal.plan;
          this.start_date = newVal.start_date;
          this.end_date = newVal.end_date;
          this.is_active = newVal.is_active;
        }
      },
    },
  },

  async mounted() {
    await this.fetchAgents();
    await this.fetchPlans();
  },

  methods: {
    ...mapActions("appData", [
      "getUsersDDL",
      "getSubscriptionPlans",
      "updateAgentSubscription"
    ]),

    async fetchAgents() {
      const res = await this.getUsersDDL();
      const list = (res.data && Array.isArray(res.data)) ? res.data : (res.data && res.data.results) ? res.data.results : [];
      const opts = list
        .filter(a => a.agent_profile)
        .map(a => ({ value: a.id, text: a.agent_profile.full_name || a.username || "Unknown" }));
      if (this.subscription && this.subscription.agent && !opts.some(o => o.value === this.subscription.agent)) {
        opts.unshift({
          value: this.subscription.agent,
          text: (this.subscription.agent_data && (this.subscription.agent_data.full_name || this.subscription.agent_data.username)) || "Current agent"
        });
      }
      this.agentOptions = opts;
    },

    async fetchPlans() {
      const res = await this.getSubscriptionPlans({ page: 1 });
      const list = (res.data && res.data.results) ? res.data.results : (Array.isArray(res.data) ? res.data : []);
      const opts = list.map(p => ({ value: p.id, text: p.name || "Unknown" }));
      if (this.subscription && this.subscription.plan && !opts.some(o => o.value === this.subscription.plan)) {
        opts.unshift({ value: this.subscription.plan, text: (this.subscription.plan_data && this.subscription.plan_data.name) || "Current plan" });
      }
      this.planOptions = opts;
    },

    async submit() {
      await this.updateAgentSubscription({
        pk: this.subscription.id,
        payload: {
          agent: this.agent,
          plan: this.plan,
          start_date: this.start_date,
          end_date: this.end_date,
          is_active: this.is_active
        }
      });

      this.$bvModal.hide("edit-agent-subscription-modal");
      this.$emit("modalClosed");
    }
  }
};
</script>